import {IAlternative, ICommonHotel, IHotel, ITotal} from "./hotel";
import {ICost, IPenalty} from "libraries/service/resources/hotel/IResourceHotel";
import {ILanguageText} from "./quote";

export interface IDataDetailsDescription {
    data: IDetailsDescription;
}

export interface IDataDetailsOffer {
    data: IDetailsOffer;
}

export interface IDetails {
    selectedHotel: IHotel | {} | null;
    offers: IDetailsOffer[];
    description: IDetailsDescription | {};
}

export interface IDetailsOffer {
    host: string;
    isWithGiata?: boolean;
    property: string;
    alternatives?: IAlternative[];
    rank: string;
    xId: string;
    detail: IDetailsOfferDetail;
    mealplan?: IMealplan;
    dateLastCancellationWithoutPenalty: string;
    total: ITotal;
    status: OfferStatus;
}

export enum OfferStatus {
    Request = 'Request',
    Available = 'Available'
}

export interface IDetailsOfferDetail {
    [key: string]: IAccommodation | IMealplan;
}

export interface IRemoteImageDescription {
    url: string;
    dimension: {
        width: number;
        height?: number;
        xUnit?: string;
    };
}

interface IDescriptionMedia {
    images: IRemoteImageDescription[];
    vignettes: IRemoteImageDescription[];
}

export interface IWebSite {
    url: string;
    /** Can be 'Internet' */
    channel: string;
}

export interface IDetailsDescription extends ICommonHotel {

    airport: string[];
    alternative?: string[];
    brand: string;
    content: string;
    customer: string;
    email: string;
    keywords: IRoomSingleKeyword[];
    keywordArray: IRoomSingleKeyword[]; //#29663 support both formats
    /** @deprecated use preferably `languageCode` when available. */
    language?: string;
    languageCode: string;
    template: string;
    name: {
        text: string;
    };
    credit?: {
        text: string;
    };
    descriptions: {
        Accomodation?: {
            [key: string]: IDescriptionObject;
        };
        Entertainment?: {
            [key: string]: IDescriptionObject;
        };
        Equipment: {
            [key: string]: IDescriptionObject;
        };
    };
    introduction?: {
        /** Provided only if language is different from user's language. */
        languageCode?: string;
        textLines: string[];
        title: string;
        medias?: IDescriptionMedia[];
        description?: IIntroductionDescription[];
    };
    accomodations: IAccomodation[];
    medias?: IDescriptionMedia[];
}

export interface IIntroductionDescription {
    type: {
        xCode: string;
    }
    title: string;
    index: string;
    languageCode: string;
    textLineArray: string[];
}

export interface IAccomodation {
    count: number;
    keywords: IRoomSingleKeyword[];
}

export interface IRoomSingleKeyword {
    xCode: string;
    name: {
        value: string;
        /** @deprecated */
        language: string;
        languageCode: string;
    };
}

export interface IRoomKeyword {
    [key: string]: IRoomSingleKeyword;
}

export interface IDescriptionObject {
    /** Provided only if description is not in user's language. */
    languageCode?: string;
    textLines: string[];
    textLine?: string[];
    title: string;
}

export enum DetailType {
    Accomodation = "accomodation",
    Mealplan = "mealplan",
}

export interface IDetail {
    xType?: DetailType;
    xId: string;
    syscode: string;
}

export interface IAccommodation extends IDetail {
    code: string;
    farebasis?: string;
    host?: string;
    dateLastCancellationWithoutPenalty?: string;
    rooming?: string;
    xCode?: string;
    xType?: DetailType.Accomodation;
    mealplan?: IMealplan;
    name: {
        text: string;
        language: string;
    };
    unit?: {
        cost: ICost;
        retail?: ICost;
    };
    penalty?: IPenalty | IPenalty[];
}

export enum MealplanCode {
    AllInclusive = 'AllInclusive',
    American = 'American',
    AmericanBreakfast = 'AmericanBreakfast',
    Breakfast = 'Breakfast',
    BreakfastBuffet = 'BreakfastBuffet',
    Bermuda = 'Bermuda',
    BermudaBreakfast = 'BermudaBreakfast',
    Carribean = 'Carribean',
    CarribeanBreakfast = 'CarribeanBreakfast',
    Continental = 'Continental',
    ContinentalBreakfast = 'ContinentalBreakfast',
    Dinner = 'Dinner',
    DinnerBuffet = 'DinnerBuffet',
    DinnerMenu = 'DinnerMenu',
    DinnerALaCarte = 'DinnerALaCarte',
    DrinksIncluded = 'DrinksIncluded',
    EnglishBreakfast = 'EnglishBreakfast',
    European = 'European',
    EuropeanBreakfast = 'EuropeanBreakfast',
    Family = 'Family',
    FoodPack = 'FoodPack',
    FullBoard = 'FullBoard',
    HalfBoard = 'HalfBoard',
    IrishBreakfast = 'IrishBreakfast',
    Lunch = 'Lunch',
    LunchBuffet = 'LunchBuffet',
    LunchDinner = 'LunchDinner',
    LunchMenu = 'LunchMenu',
    LunchALaCarte = 'LunchALaCarte',
    ModifiedAmerican = 'ModifiedAmerican',
    NoMealIncluded = 'NoMealIncluded',
    ScottishBreakfast = 'ScottishBreakfast',
    SelfCatering = 'SelfCatering',
    Snack = 'Snack',
    SpecialMeal = 'SpecialMeal',
    Unknown = 'Unknown',
}

export interface IMealplan extends IDetail {
    code: string;
    xCode?: MealplanCode;
    xType?: DetailType.Mealplan;
    name: ILanguageText;
    xStatus?: string;
}
